import { products } from "../../constants/metrics";
import getEnvironDomain from "../../utils/getEnvironDomain";

const baseUrl = getEnvironDomain();

const links = {
  MAIN: `https://${baseUrl}`,
  NEWS: `https://news.${baseUrl}/index/`,
  RATING: `https://${baseUrl}/rating/`,
  YOUR_TRUCKS: `https://trucks.${baseUrl}/published`,
  YOUR_LOADS: `https://loads.${baseUrl}/published`,
  OFFICE: `https://${baseUrl}/office/`,
  VERIFICATION: `https://${baseUrl}/verification/`,
  CARGO_SEARCH: `https://loads.${baseUrl}/`,
  FORUM: `https://forums.${baseUrl}/forum/`,
};
// \u00A0 - неразрывный пробел
// \n\n - новый абзац
// \u2011 - неразрывное тире

const ndsPopup = {
  image: `https://files.${baseUrl}/static/front-files/popup-to-25-05-25.png`,
  header:
    "НДС в\u00A02025: как\u00A0не\u00A0попасть под\u00A0штрафы. Бесплатный вебинар от\u00A0ATI.SU",
  content: "Главный юрист ATI.SU расскажет, как\u00A0последние изменения НДС повлияют на\u00A0работу перевозчиков и\u00A0экспедиторов. Участие бесплатное — нужно только зарегистрироваться.",
  actionText: "Зарегистрироваться",
  actionLink: "https://academy.ati.su/webinars/nds2/",
  enableURLs: [links.MAIN, links.YOUR_TRUCKS, links.RATING],
  utms: {
    source: "popup-update",
    campaign: "nds2",
  },
  position: "bottomRight",
  startDate: "2025-05-19",
  finishDate: "2025-05-25",
  metrics: {
    dataLakeOnClick: products.ACADEMY,
    dataLakeOnShow: products.ACADEMY,
  },
};

const courierPopup = {
  image: `https://files.${baseUrl}/static/front-files/popup-to-30-05-25.png`,
  header: "Найдём службу доставки, в\u00A0которой будет максимум преимуществ",
  content: "Быстрые курьеры, выгодные тарифы и\u00A0комфортные условия\u00A0—\u00A0уже в\u00A0сервисе «АТИ Курьер». Воспользуйтесь доставкой документов и\u00A0личных посылок.",
  actionText: "Расскажите больше",
  actionLink: "https://ati.su/landings/ati-courier/",
  enableURLs: [links.MAIN, links.NEWS],
  utms: {
    source: "popup-update",
    campaign: "popus-courier-2",
  },
  position: "bottomRight",
  startDate: "2025-05-26",
  finishDate: "2025-05-30",
};

const CISNewcomer = {
  image: `https://files.${baseUrl}/static/front-files/popup-to-01-06-25.png`,
  header: "Бесплатный курс про\u00A0ATI.SU для\u00A0экспедиторов",
  content: "За\u00A06\u00A0коротких уроков от\u00A0Академии ATI.SU вы\u00A0научитесь\u00A0быстрее искать машины, проверять заказчиков и\u00A0перевозчиков, продвигать свой аккаунт и\u00A0избегать частых ошибок в\u00A0работе на\u00A0сайте.",
  actionText: "Пройти курс",
  actionLink: "https://academy.ati.su/forwarders-start/",
  enableURLs: [links.MAIN, links.YOUR_LOADS, links.RATING],
  utms: {
    source: "popup-update",
    campaign: "forwarders-start-cis",
  },
  position: "bottomRight",
  startDate: "2025-05-26",
  finishDate: "2025-06-01",
  metrics: {
    dataLakeOnClick: products.ACADEMY,
    dataLakeOnShow: products.ACADEMY,
  },
};

const smallTonnage = {
  image: `https://files.${baseUrl}/static/front-files/popup-to-08-06-25.png`,
  header: "Где выше ставки и\u00A0больше грузов?",
  content: "Узнайте в\u00A0сервисе «Выгодные направления». Теперь\u00A0вы\u00A0можете найти новые возможности и\u00A0маршруты для машин 1,5\u00A0т,\u00A03\u00A0т,\u00A05\u00A0т,\u00A010\u00A0т\u00A0и\u00A020\u00A0т.",
  actionText: "Подробнее",
  actionLink: "https://ati.su/analytics/profit-directions",
  enableURLs: [links.MAIN, links.YOUR_TRUCKS, links.RATING],
  utms: {
    source: "popup-update",
    campaign: "maliy-tonnazh-pd",
  },
  position: "bottomRight",
  startDate: "2025-06-02",
  finishDate: "2025-06-08",
  metrics: {
    dataLakeOnClick: products.AverageRates,
    dataLakeOnShow: products.AverageRates,
  },
};

const popupsData = {
  372: ndsPopup,
  373: ndsPopup,
  374: ndsPopup,
  375: ndsPopup,
  376: ndsPopup,
  377: courierPopup,
  378: courierPopup,
  379: courierPopup,
  380: courierPopup,
  381: CISNewcomer,
  383: smallTonnage,
  385: smallTonnage,
  386: smallTonnage,
  387: smallTonnage,
  388: smallTonnage,
};

const mapIdTemplate = Object.keys(popupsData).reduce((acc, id) => {
  acc[id] = "updates-template";
  return acc;
}, {});

export { popupsData, mapIdTemplate };
